{
  "version": 1,
  "asset_id": "a2299fce-10bf-47f3-a9e1-2e69241da2dd",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/a2299fce-10bf-47f3-a9e1-2e69241da2dd/lecanto-fl-standing-seam-galvalume-metal-roof-destination-roofing-480w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/a2299fce-10bf-47f3-a9e1-2e69241da2dd/lecanto-fl-standing-seam-galvalume-metal-roof-destination-roofing-480w.webp",
  "original_filename": "lecanto-fl-standing-seam-galvalume-metal-roof-destination-roofing-480w.webp",
  "size": 14894,
  "content_type": "image/webp",
  "created_at": "2026-08-27T15:21:00Z"
}
